<!-- CyclingConditions.vue - ADFC Fahrradklimatest scores for the report's city (German school grades, 1 best to 6 worst) -->
<template>
  <section v-if="cyclingConditions" class="cycling card fade-in" :aria-labelledby="'cyc-h-' + uid">
    <h2 :id="'cyc-h-' + uid">{{ $t('explore.advice.cycling.title') }} {{ cyclingConditions.location }}</h2>
    <p class="caption">{{ $t('explore.advice.cycling.caption') }}</p>

    <p v-if="cyclingConditions['Rank']" class="rank">
      <span>{{ $t('explore.advice.cycling.ranking') }}</span>
      <span class="pill">{{ $t('explore.advice.cycling.rank', { n: cyclingConditions['Rank'] }) }}</span>
    </p>

    <ul class="scores">
      <li v-for="row in rows" :key="row.key">
        <div class="score-head">
          <span class="name">{{ row.name }}</span>
          <span class="value">{{ row.value }} · {{ row.grade }}</span>
        </div>
        <!-- decorative: the number and grade word above carry the meaning -->
        <div class="track" aria-hidden="true"><span class="fill" :style="{ width: row.pct + '%' }"></span></div>
      </li>
    </ul>
    <p class="scale" aria-hidden="true"><span>{{ $t('explore.advice.cycling.best') }}</span><span>{{ $t('explore.advice.cycling.worst') }}</span></p>

    <button type="button" class="more" :aria-expanded="showDetails ? 'true' : 'false'" :aria-controls="'cyc-d-' + uid" @click="showDetails = !showDetails">
      {{ showDetails ? $t('explore.advice.cycling.less') : $t('explore.advice.cycling.more') }}
      <i :class="['fas', showDetails ? 'fa-chevron-up' : 'fa-chevron-down']" aria-hidden="true"></i>
    </button>
    <dl v-show="showDetails" :id="'cyc-d-' + uid" class="details">
      <template v-for="(value, key) in filteredCyclingConditions" :key="key">
        <dt>{{ key }}</dt>
        <dd>{{ value }}<span v-if="cyclingConditions['BIC_' + key]"> · {{ cyclingConditions['BIC_' + key] }}</span></dd>
      </template>
    </dl>

    <p class="source">
      {{ $t('explore.advice.cycling.data') }}
      <a target="_blank" rel="noopener noreferrer" href="https://fahrradklima-test.adfc.de/ergebnisse">ADFC Fahrradklimatest 2022</a>
    </p>
  </section>
</template>

<script>
let counter = 0;

export default {
  name: 'CyclingConditions',
  props: {
    city: { type: String, required: true },
    cyclingConditions: { type: Object, required: true },
  },
  data() {
    return { showDetails: false, uid: ++counter };
  },
  computed: {
    rows() {
      const c = this.cyclingConditions || {};
      return [
        ['Overall Rating', 'explore.advice.cycling.overall'],
        ['Safety_in_Cycling', 'explore.advice.cycling.safety'],
        ['Comfort_in_Cycling', 'explore.advice.cycling.comfort'],
      ]
        .filter(([key]) => c[key] !== null && c[key] !== undefined && Number.isFinite(Number(c[key])))
        .map(([key, msg]) => {
          const n = Number(c[key]);
          const grade = Math.min(6, Math.max(1, Math.round(n)));
          return {
            key,
            name: this.$t(msg).replace(/:$/, ''),
            value: n.toFixed(2).replace(/0$/, ''),
            grade: this.$t('explore.advice.cycling.grade.' + grade),
            pct: Math.round(((Math.min(6, Math.max(1, n)) - 1) / 5) * 100),
          };
        });
    },
    filteredCyclingConditions() {
      return Object.keys(this.cyclingConditions).reduce((result, key) => {
        if (!key.startsWith('BIC_')) result[key] = this.cyclingConditions[key];
        return result;
      }, {});
    },
  },
};
</script>

<style scoped>
.cycling { display: flex; flex-direction: column; gap: 12px; text-align: start; }
h2 { margin: 0; font-size: 18px; }
.caption, .source, .scale, .rank { margin: 0; font-size: 14px; color: var(--color-secondary); }
.rank { display: flex; align-items: center; justify-content: space-between; color: var(--color-text); font-weight: 500; }
:global(body.dark-mode) .rank { color: var(--color-text-light); }
.pill { padding: 4px 12px; border-radius: var(--radius-pill); background: var(--color-primary); color: var(--color-on-primary); font-size: 12px; }
.scores { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 12px; }
.score-head { display: flex; justify-content: space-between; gap: 8px; font-weight: 500; font-size: 14px; }
.track { height: 8px; margin-top: 4px; border-radius: 4px; background: var(--color-subtle); overflow: hidden; }
.fill { display: block; height: 100%; background: var(--color-primary); }
.scale { display: flex; justify-content: space-between; font-size: 12px; }
.more { align-self: flex-start; min-height: var(--touch-min); padding: 0 12px; border: 0; background: transparent; color: var(--color-primary-text); font: inherit; font-weight: 600; cursor: pointer; }
.details { margin: 0; display: grid; grid-template-columns: auto 1fr; gap: 4px 12px; font-size: 14px; text-align: left; }
.details dt { color: var(--color-secondary); }
.details dd { margin: 0; text-align: right; }
.source a { color: var(--color-primary-text); }
</style>
